import { Reveal } from "@components/ui";
import type { ReactNode } from "react";

interface Regulation {
  label: string;
  icon: ReactNode;
}

const regulations: Regulation[] = [
  {
    label: "UAE Fire & Life Safety Code",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" className="w-5 h-5 md:w-6 md:h-6">
        <path
          d="M12 22c3.5 0 6-2.5 6-6 0-4-3-7-6-10-3 3-6 6-6 10 0 3.5 2.5 6 6 6z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
  },
  {
    label: "Dubai Civil Defense",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" className="w-5 h-5 md:w-6 md:h-6">
        <path
          d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
  },
  {
    label: "ESMA Gas Safety",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" className="w-5 h-5 md:w-6 md:h-6">
        <path
          d="M9 12l2 2 4-4"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12 22c5.5 0 10-4.5 10-10S17.5 2 12 2 2 6.5 2 12s4.5 10 10 10z"
          stroke="currentColor"
          strokeWidth="1.5"
        />
      </svg>
    ),
  },
  {
    label: "FTA VAT Regulations",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" className="w-5 h-5 md:w-6 md:h-6">
        <path
          d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14 2v6h6M12 18v-6M9 15l3 3 3-3"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
  },
];

export function TaxesComplianceSection() {
  return (
    <section className="w-full bg-white overflow-hidden pt-8 md:pt-12 lg:pt-[80px] pb-6 md:pb-8 lg:pb-[48px] px-5 md:px-10 lg:px-[180px]">
      <div className="w-full max-w-[1368px] mx-auto">
        <div className="flex flex-col lg:flex-row items-start lg:items-center justify-between gap-8 md:gap-12 lg:gap-10">
          <Reveal direction="left" className="flex-1 min-w-0 lg:max-w-[788px]">
            <div className="flex flex-col gap-4 md:gap-[22.5px]">
              <span className="inline-block px-4 py-1.5 rounded-full bg-[#122d63]/8 text-[#122d63] text-[13px] md:text-[15px] font-semibold tracking-[-0.02em] uppercase font-albert-sans w-fit">
                Compliance
              </span>
              <h2 className="text-[24px] md:text-[40px] lg:text-[54px] tracking-[-0.04em] font-semibold text-[#122d63] font-albert-sans leading-[1.1]">
                Taxes & Compliance
              </h2>
              <div className="flex flex-col gap-3 md:gap-3.5">
                <p className="text-[14px] md:text-base lg:text-[24px] tracking-[-0.04em] leading-[32px] text-[#62636c] font-albert-sans">
                  All fees and tariffs are exclusive of VAT (5%).
                </p>
                <p className="text-[14px] md:text-base lg:text-[24px] tracking-[-0.04em] leading-[32px] text-[#62636c] font-albert-sans">
                  GASIS is fully registered with the Federal Tax Authority (FTA)
                  and issues tax invoices showing its TRN number on every bill.
                </p>
                <p className="text-[14px] md:text-base lg:text-[24px] tracking-[-0.04em] leading-[32px] text-[#62636c] font-albert-sans">
                  Regulatory compliance is maintained under:
                </p>
              </div>
            </div>
          </Reveal>

          <Reveal direction="right" className="w-full lg:w-auto shrink-0">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 md:gap-4">
              {regulations.map((reg) => (
                <div
                  key={reg.label}
                  className="rounded-[12px] md:rounded-[16px] bg-[#f6f6f9] border border-transparent hover:border-[#122d63]/15 hover:bg-white hover:shadow-[0_4px_20px_rgba(18,45,99,0.08)] p-4 md:p-6 flex items-center gap-3 md:gap-4 min-h-[80px] md:min-h-[100px] transition-all duration-300 group"
                >
                  <div className="w-10 h-10 md:w-12 md:h-12 rounded-[10px] bg-[#122d63]/8 text-[#122d63] group-hover:bg-[#122d63] group-hover:text-white flex items-center justify-center shrink-0 transition-all duration-300">
                    {reg.icon}
                  </div>
                  <p className="text-[14px] md:text-base lg:text-[20px] tracking-[-0.04em] font-medium text-[#122d63] font-albert-sans">
                    {reg.label}
                  </p>
                </div>
              ))}
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
